import React, { useState } from 'react';
import css from './SearchFilterNarrowContent.module.css';
import {
  DatePickerField,
  H3,
  Paragraph,
  StackedColumn,
  StackedColumnSpacing,
  StackedRow,
  StackedRowSpacing,
  TextLink,
} from '../../../../../../core';
import { LocationOptions } from '../../../../../../utils';
import { LocationChoiceDialog } from './locationChoiceDialog';

export interface SearchFilterNarrowContentProps {
  date: Date | null | undefined;
  locationId: string;
  showLocationOptions: boolean;
  locationList: LocationOptions[];
  filterChanged: (date: Date | null | undefined, locationId: string) => void;
}

const SearchFilterNarrowContent: React.FC<SearchFilterNarrowContentProps> = (
  props: SearchFilterNarrowContentProps
) => {
  const [showEditLocationModal, setShowEditLocationModal] =
    useState<boolean>(false);

  const onDateChange = (value: Date | null | undefined) => {
    props.filterChanged(value, props.locationId);
  };

  const selectedLocationOption = props.locationList.find(
    (option) => option.value === props.locationId
  );

  const onEditLocationClicked = () => {
    setShowEditLocationModal(true);
  };

  const onCloseEditLocationModal = () => {
    setShowEditLocationModal(false);
  };

  const onLocationPicked = (locationId: string) => {
    props.filterChanged(props.date, locationId);
    setShowEditLocationModal(false);
  };

  return (
    <>
      <StackedColumn spacing={StackedColumnSpacing.Tight}>
        <H3 text="Refine search" />
        <div className={css.dateFieldWrapper}>
          <DatePickerField
            label="Select a date (MM/DD/YYYY)"
            onDateChange={onDateChange}
            value={props.date}
          />
        </div>
        <Paragraph small={true} bold={true} text="Location" />
        <StackedRow spacing={StackedRowSpacing.NoGap}>
          <Paragraph text={selectedLocationOption?.label ?? ''} />
          <div className={css.editButtonDiv}>
            <TextLink caption="Edit" onClick={onEditLocationClicked} />
          </div>
        </StackedRow>
      </StackedColumn>
      {showEditLocationModal ? (
        <LocationChoiceDialog
          isOpen={showEditLocationModal}
          locationId={props.locationId}
          locationList={props.locationList}
          onClose={onCloseEditLocationModal}
          onLocationPicked={onLocationPicked}
        />
      ) : null}
    </>
  );
};

export default SearchFilterNarrowContent;
